
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { imageBaseUrl } from '../utils/apiInstance';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import './Table.css';

const Tables = ({
  restaurant,
  waiter,
  menu,
  menuLinks,
  category,
  request,
  contactUs,
  data,
  handleSwitchChange,
  handleDeleteClick,
  heading,
  options,
  searchQuery,
  setSearchQuery,
  loading,
  navigateId
}) => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid" id="tableContainer">
      <div className="row">
        <div className="col-12">
          <div className="card my-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div className="bg-info shadow-dark border-radius-lg d-flex justify-content-between align-items-center">
                <h6 className="text-white text-capitalize ps-3" id="tableHead">
                  {heading}
                </h6>

              </div>
            </div>

            <div className="section-body">
              <div className="card">
                <div className="card-body">
                  <div className="align-items-center d-flex justify-content-end mb-3">
                    <div className='me-1'>
                      <input
                        type="text"
                        placeholder='Search'
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="border border-1 form-control px-2"
                        style={{ maxWidth: '300px', backgroundColor: 'white' }}
                      />
                    </div>
                    {/* waiter */}
                    {waiter &&
                      <div >
                        <button
                          type="button"
                          data-tooltip-id="addBtn" data-tooltip-content="add waiter"
                          className="btn btn-info add_btn text-white my-0 mx-1"
                          onClick={() => navigate(`/addwaiter/${navigateId}`)}
                        >
                          Add
                        </button>
                      </div>
                    }
                    {/* restaurant */}
                    {restaurant &&
                      <div >
                        <button
                          type="button"
                          data-tooltip-id="addBtn" data-tooltip-content="add restaurant"
                          className="btn btn-info add_btn text-white my-0 mx-1"
                          onClick={() => navigate('/addrestaurant')}
                        >
                          Add
                        </button>
                      </div>
                    }
                  </div>

                  <div className="table-responsive">
                    <table className="table text-center align-items-center resturent_table">
                      <thead>
                        <tr>
                          {options.map((option, indx) => (
                            <th key={indx}>{option}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>

                        {/* restaurant */}
                        {restaurant &&
                          data.map((restaurant, index) => (
                            <tr key={restaurant.id}>
                              <td>{index + 1}</td>
                              <td>
                                {restaurant.user?.image ? (
                                  <img
                                    src={`${imageBaseUrl}/${restaurant.user?.image}`}
                                    alt="profile"
                                    className='tableimg'
                                  />
                                ) : (
                                  'No Image'
                                )}
                              </td>
                              <td>{restaurant.name || ''}</td>
                              <td>{restaurant.user.name || ''}</td>
                              <td>
                                <div className="form-check form-switch d-flex align-items-center justify-content-center">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`toggleStatus${restaurant.id}`}
                                    checked={restaurant.status === 1}
                                    onChange={() => handleSwitchChange(restaurant.id, restaurant.status)}
                                    style={{
                                      backgroundColor: restaurant.status === 1 ? '#57cbff' : 'lightgray',
                                      borderColor: restaurant.status === 1 ? '#57cbff' : 'lightgray',
                                    }}
                                  />
                                </div>
                              </td>
                              <td>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="view"
                                  to={`/viewrestaurant/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-eye" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="edit"
                                  to={`/editrestaurant/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-edit" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="special requests"
                                  to={`/requestlist/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-comment-dots" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="waiters"
                                  to={`/waiterlist/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-person" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="categories"
                                  to={`/categorylist/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-layer-group" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="menu items"
                                  to={`/menuitems/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-hamburger" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="menu link"
                                  to={`/menulinks/${restaurant.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-link" />
                                </Link>

                                <button
                                  onClick={() => handleDeleteClick(restaurant.id)}
                                  className="has-icon btn m-1 bg-danger"
                                  data-tooltip-id="my-tooltip" data-tooltip-content="delete"
                                  style={{
                                    borderColor: '#110011',
                                    color: '#fff',
                                  }}
                                >
                                  <i className="me-100 fas fa-trash" />
                                </button>

                              </td>
                            </tr>
                          ))}

                        {/* category */}
                        {category &&
                          data.map((category, index) => (
                            <tr key={category.id}>
                              <td>{index + 1}</td>
                              <td>
                                {category.image ? (
                                  <img
                                    src={`${imageBaseUrl}/${category.image}`}
                                    alt="profile"
                                    className='tableimg'
                                  />
                                ) : (
                                  'No Image'
                                )}
                              </td>
                              <td>{category.name || ''}</td>
                              <td><span className={`text-bold ${category.status === 1 ? "text-success" : "text-danger"}`}>{category.status === 1 ? "Active" : "Inactive"}</span></td>
                              <td>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="view"
                                  to={`/viewcategory/${category.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-eye" />
                                </Link>
                              </td>
                            </tr>
                          ))}

                        {/* request */}
                        {request &&
                          data.map((request, index) => (
                            <tr key={request.id}>
                              <td>{index + 1}</td>
                              <td>{request.type_of_request || ''}</td>
                              <td>
                                <span className={`text-bold ${request.status === 1 ? "text-success" : "text-danger"}`}>{request.status === 1 ? "Active" : "Inactive"}</span>
                              </td>
                            </tr>
                          ))}

                        {/* waiter */}
                        {waiter &&
                          data.map((waiter, index) => (
                            <tr key={waiter.id}>
                              <td>{index + 1}</td>
                              <td>
                                {waiter.image ? (
                                  <img
                                    src={`${imageBaseUrl}/${waiter.image}`}
                                    alt="profile"
                                    className='tableimg'
                                  />
                                ) : (
                                  'No Image'
                                )}
                              </td>
                              <td>{waiter.name || ''}</td>
                              <td>{waiter.email || ''}</td>
                              <td>{waiter.phone || ''}</td>
                              <td>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="view"
                                  to={`/viewwaiter/${waiter.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-eye" />
                                </Link>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="edit"
                                  to={`/editwaiter/${waiter.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-edit" />
                                </Link>
                                <button
                                  onClick={() => handleDeleteClick(waiter.id)}
                                  className="has-icon btn m-1 bg-danger"
                                  data-tooltip-id="my-tooltip" data-tooltip-content="delete"
                                  style={{
                                    borderColor: '#110011',
                                    color: '#fff',
                                  }}
                                >
                                  <i className="me-100 fas fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}


                        {/* menu */}
                        {menu &&
                          data.map((menu, index) => (
                            <tr key={menu.id}>
                              <td>{index + 1}</td>
                              <td>
                                {menu.itemImages.length > 0 && menu.itemImages[0].images ? (
                                  (() => {
                                    const firstImage = menu.itemImages[0].images.split(",")[0].trim();
                                    return (
                                      <img
                                        src={`${imageBaseUrl}/${firstImage}`}
                                        alt="item-image"
                                        className='tableimg'
                                      />
                                    );
                                  })()
                                ) : (
                                  'No Image'
                                )}

                              </td>
                              <td>{menu.name || ''}</td>
                              <td>{menu.category?.name || ''}</td>
                              <td>{`$ ${menu.price}` || ''}</td>
                              <td>{menu.availability === 1 ? 'Available' : (menu.availability === 0 ? 'Sold Out' : '')}</td>
                              <td>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="view"
                                  to={`/viewmenu/${menu.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-eye" />
                                </Link>

                              </td>
                            </tr>
                          ))}

                        {/* menuLinks */}
                        {menuLinks &&
                          data.map((link, index) => (
                            <tr key={link.id}>
                              <td>{index + 1}</td>
                              <td><a href={link.menu_link} target='_blank' style={{ color: "blue" }}>{link.menu_link || ''}</a></td>
                              <td>
                                <span className={`text-bold ${link.status === 1 ? "text-success" : "text-danger"}`}>{link.status === 1 ? "Active" : "Inactive"}</span>
                              </td>

                            </tr>
                          ))}

                        {/* contactUs */}
                        {contactUs &&
                          data.map((user, index) => (
                            <tr key={user.id}>
                              <td>{index + 1}</td>
                              <td>{user.name || ''}</td>
                              <td>{user.email || ''}</td>
                              <td>{user.phone || ''}</td>
                              <td>
                                <Link
                                  data-tooltip-id="my-tooltip" data-tooltip-content="view"
                                  to={`/viewcontactus/${user.id}`}
                                  className="has-icon btn m-1 bg-info"
                                  style={{
                                    color: 'white',
                                  }}
                                >
                                  <i className="me-100 fas fa-eye" />
                                </Link>
                                <button
                                  onClick={() => handleDeleteClick(user.id)}
                                  className="has-icon btn m-1 bg-danger"
                                  data-tooltip-id="my-tooltip" data-tooltip-content="delete"
                                  style={{
                                    borderColor: '#110011',
                                    color: '#fff',
                                  }}
                                >
                                  <i className="me-100 fas fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}

                      </tbody>
                    </table>
                  </div>
                  {loading ? <div></div> : data.length === 0 && <div className='text-info text-center' style={{ fontSize: '20px' }}>No data found..</div>}

                  {(waiter || menu || category || request || menuLinks) && <div className=" text-end mt-4">
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={() => navigate('/restaurantlist')}
                    >
                      Back
                    </button>
                  </div>
                  }
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Tooltip id="my-tooltip" place="top" type="dark" effect="solid" />
      <Tooltip id="addBtn" place="bottom" type="dark" effect="solid" style={{ zIndex: '100' }} />
    </div>
  );
};

export default Tables;

